// Define a function to avoid duplicating qrMarginBottom, fontSize, and other common properties
const commonQRCodeSettings = {
    qrMarginBottom: 5,
    fontSize: 6,
};

// Create a function to generate template settings
const createTemplateSettings = (templatePath, page, qrPosition, qrDimensions) => ({
    templatePDFPath: templatePath,
    page,
    qrPosition,
    qrDimensions,
    ...commonQRCodeSettings,
});

// Use a base QR position and dimensions structure where possible
const defaultQRPosition = { x: 5, y: 5 };
const qrPosition_A5_L = { x: 355, y: 125 };
const qrDimesions_90 = { width: 90, height: 90 };
const qrPosition_A6_L = { x: 258, y: 107 };
const qrPosition_A6_P = { x: 222, y: 240 };
const qrDimensions_65 = { width: 65, height: 65 };
const qrPosition_A7_P = { x: 93, y: 150 };
const qrDimensions_180 = { width: 180, height: 180 };
// Specific adjustments for certain templates, with potential overrides for QR dimensions, positions, or pages.
export const templateSettings = {
    A5: {
        Landscape: {
            "NL/FR": createTemplateSettings('/templates/A5_VECTOR_B.pdf', 1, qrPosition_A5_L, qrDimesions_90),
            "FR/NL": createTemplateSettings('/templates/A5_VECTOR_B.pdf', 2, qrPosition_A5_L, qrDimesions_90),
            "NL": createTemplateSettings('/templates/A5_VECTOR_B.pdf', 3, qrPosition_A5_L, qrDimesions_90),
            "FR": createTemplateSettings('/templates/A5_VECTOR_B.pdf', 4, qrPosition_A5_L, qrDimesions_90),
            "FR/DE": createTemplateSettings('/templates/A5_VECTOR_B.pdf', 5, qrPosition_A5_L, qrDimesions_90),
        },
    },
    A6: {
        Landscape: {
            "NL/FR": createTemplateSettings('/templates/A6horizontal_VECTOR.pdf', 1, qrPosition_A6_L, qrDimesions_90),
            "FR/NL": createTemplateSettings('/templates/A6horizontal_VECTOR.pdf', 2, qrPosition_A6_L, qrDimesions_90),
            "NL": createTemplateSettings('/templates/A6horizontal_VECTOR.pdf', 3, qrPosition_A6_L, qrDimesions_90),
            "FR": createTemplateSettings('/templates/A6horizontal_VECTOR.pdf', 4, qrPosition_A6_L, qrDimesions_90),
            "FR/DE": createTemplateSettings('/templates/A6horizontal_VECTOR.pdf', 5, qrPosition_A6_L, qrDimesions_90),
        },
        Portrait: {
            "NL/FR": createTemplateSettings('/templates/A6_VECTOR_B.pdf', 1, qrPosition_A6_P, qrDimensions_65),
            "FR/NL": createTemplateSettings('/templates/A6_VECTOR_B.pdf', 2, qrPosition_A6_P, qrDimensions_65),
            "NL": createTemplateSettings('/templates/A6_VECTOR_B.pdf', 3, qrPosition_A6_P, qrDimensions_65),
            "FR": createTemplateSettings('/templates/A6_VECTOR_B.pdf', 4, qrPosition_A6_P, qrDimensions_65),
            "FR/DE": createTemplateSettings('/templates/A6_VECTOR_B.pdf', 5, qrPosition_A6_P, qrDimensions_65),
        },
    },
    A7: {
        Landscape: {
            "NL/FR": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, defaultQRPosition, qrDimesions_90),
            "FR/NL": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, defaultQRPosition, qrDimesions_90),
            "NL": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, defaultQRPosition, qrDimesions_90),
            "FR": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, defaultQRPosition, qrDimesions_90),
            "FR/DE": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, defaultQRPosition, qrDimesions_90),
        },
        Portrait: {
            "NL/FR": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, qrPosition_A7_P, qrDimensions_180),
            "FR/NL": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, qrPosition_A7_P, qrDimensions_180),
            "NL": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, qrPosition_A7_P,  qrDimensions_180),
            "FR": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, qrPosition_A7_P,  qrDimensions_180),
            "FR/DE": createTemplateSettings('/templates/A7_OK_ai.pdf', 1, qrPosition_A7_P, qrDimensions_180),
        },
    },
};
